import { useEffect, useState, useCallback } from 'react';
import { io, Socket } from 'socket.io-client';

export let socket: Socket | null = null;

export const useWebSocket = () => {
  const [token, setToken] = useState('');
  const [_socket, setSocket] = useState<Socket | null>(socket);
  const init = useCallback((access_token: string) => {
    setToken(access_token);
  }, []);

  useEffect(() => {
    if (!token) {
      return;
    }

    if (socket) {
      socket.disconnect();
    }

    const apiServerUrl = import.meta.env.VITE_APP_API_SERVER;
    if (!apiServerUrl) {
      console.error('VITE_APP_API_SERVER is not defined');
      return;
    }
    const serverUrl = apiServerUrl.startsWith('/')
      ? window.location.origin
      : apiServerUrl;
    socket = io(serverUrl, {
      extraHeaders: { Authorization: token },
    });
    setSocket(socket);

    return () => {
      socket?.disconnect();
      setSocket(null);
    };
  }, [token]);

  return [
    _socket,
    {
      init,
    },
  ] as [Socket | null, any];
};

export default useWebSocket;
